<template>
<div class="container">
    <!--<van-nav-bar title="套餐详情" left-arrow @click-left="onClickLeft"-->
    <!--&gt;</van-nav-bar>-->
    <div class="member-detail">
      <div class="member-section">
        <h4>基础信息</h4>
        <div class="member-box">
          <van-cell-group :border="noBorder">
            <van-field :border="noBorder" v-model="userName" label="姓名" placeholder="请输入用户姓名" ></van-field>
            <van-cell title="性别">
              <van-radio-group v-model="sex" class="flex-rss">
                <van-radio checked-color="#fa4e26"  name="1">先生</van-radio>
                <van-radio checked-color="#fa4e26"  name="2">女士</van-radio>
              </van-radio-group>
            </van-cell>
            <van-field :border="noBorder" type="tel" v-model="mobile" label="手机号" placeholder="请输入手机号" :error-message="phoneError" ></van-field>
            <van-cell title="生日" @click.stop="showDate = true">
              <div style="text-align: left">{{ birthday || '请输入生日' }}</div>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
      <div class="member-section">
        <h4>设置支付密码</h4>
        <div class="member-box">
          <van-cell-group :border="noBorder">
            <!--<van-field :value="password" maxlength="6" type="password" label="设置密码" placeholder="请输入6位数字密码" disabled @touchstart.stop="passwordShow = true"></van-field>-->
            <!--<van-field v-model="confirmPassword" maxlength="6" type="digit" label="确认密码" placeholder="请输入6位数字密码" ></van-field>-->
            <van-field
                readonly
                clickable
                :value="password"
                type="password"
                maxlength="6"
                label="设置密码" placeholder="请输入6位数字密码"
                @touchstart.native.stop="passwordShow = true, show = false"></van-field>
            <van-field
                readonly
                clickable
                :value="confirmPassword"
                type="password"
                maxlength="6"
                label="确认密码" placeholder="请输入6位数字密码"
                @touchstart.native.stop="show = true, passwordShow = false"></van-field>
          </van-cell-group>
        </div>
      </div>
      <div class="member-section">
        <h4>推荐人</h4>
        <div class="member-box">
          <van-cell-group :border="noBorder">
            <van-field :border="noBorder" v-model="referrer" placeholder="请输入推荐人工号或姓名" ></van-field>
          </van-cell-group>
        </div>
      </div>
      <div class="bottom-bar-placeholder"></div>
      <div class="bottom-bar">
        <div class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" @click="payInfo">保存</div>
      </div>
      <van-popup v-model="showDate" position="bottom">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          :value="currentDate"
          :formatter="formatter"
          @confirm="confirm"
          @cancel="cancel"
        ></van-datetime-picker>
      </van-popup>
      <van-number-keyboard
          :show="passwordShow"
          v-model="password"
          :maxlength="6"
          close-button-text="完成"
          @blur="passwordShow = false"
          @input="onInput"
          @delete="onDelete"></van-number-keyboard>
      <van-number-keyboard
          :show="show"
          v-model="confirmPassword"
          :maxlength="6"
          close-button-text="完成"
          @blur="show = false"
          @input="onInput"
          @delete="onDelete"></van-number-keyboard>
      <modal :visible="showModal" @ok="payInfo" @hideModal="hideModal" title="手机验证码">
        <div class="flex-rbc code-box">
          <van-field  class="code-input" :border="noBorder" v-model="checkCode" maxlength="4" type="digit" placeholder="输入验证码" ></van-field>
        </div>
      </modal>
    </div>
</div>
</template>

<script>
import WXPay from '../../util/wxpay'
import { mapState } from 'vuex'
import { DatetimePicker } from "vant";
import modal from '@/components/common/modal'
export default {
  name: "memberInfo",
  data() {
    return {
      noBorder: false,
      userName: "",
      mobile: "",
      sex: "",
      password: "",
      confirmPassword: "",
      birthday: "",
      minDate: new Date(1940, 1, 1),
      currentDate: new Date(1990, 1, 1),
      showDate: false,
      phoneError: "",
      payTypeStr: '',
      loading: false,
      cardId: '',
      packageId: '',
      referrer: '',
      passwordShow: false,
      show: false,
      showModal: false,
      checkCode: ''
    };
  },
  computed: {
    ...mapState(['isApp', 'openId'])
  },
  components: {
    [DatetimePicker.name]: DatetimePicker,
    modal
  },
  mounted () {
    const { packageId = '', cardId = '' } = this.$route.query
    console.log('packageId', packageId)
    console.log('cardId', cardId)
    this.cardId = cardId
    this.packageId = packageId
    console.log('currentDate', this.currentDate)
  },
  methods: {
    payInfo () {
      let { payTypeStr, userName, sex, mobile, password, confirmPassword, birthday, loading, cardId, packageId, referrer, openId, checkCode = '' } = this
      if (!userName) return this.$toast('姓名不能为空！')
      if (!mobile) return this.$toast('手机号不能为空！')
      if (!password) return this.$toast('密码不能为空！')
      console.log('password.length', password.length)
      if (password.length !== 6) return this.$toast('请输入6位数字密码!')
      if (!confirmPassword) return this.$toast('密码不能为空！')
      if (password !== confirmPassword) return this.$toast('密码与确认密码不一致!')
      let source
      if (this.isApp === 'isAlipay') {
        source = '3'
        payTypeStr = 6
      } else if (this.isApp === 'isWeixin') {
        payTypeStr = 5
        source = '2'
      }
      birthday = birthday.replace(/-/g, '')
      if (loading) return
      this.loading = true
      this.$api.pay.openCardPayInfo({
        payType: payTypeStr,
        userName,
        mobile,
        password,
        birthday,
        sex,
        packageId,
        cardId,
        openId,
        referrer,
        source,
        checkCode
      }).then(res => {
        console.log('res', res)
        this.checkCode = ''
        if (res.errCode === '0') {
          // const { payType } = res.data
          this.loading = false
          console.log('payInfoApi', res.data)
          console.log('isApp', this.isApp)
          const { payType, userToken = '' } = res.data
          let token = userToken || this.$store.state.userToken
          console.log('token', token)
          this.$store.commit('userToken', token)
          if (payType === 'wxPay') { // 微信支付
            this.callWXPay(res.data)
          } else if (payType === 'aliPay') {
            this.aliPay(res.data)
          } else if (payType === 'cardPay') {
            this.paySuccess(res.data)
          } else if (payType === 'couponPay') {
            this.paySuccess(res.data)
          }
        } else if (res.errCode === '11011') {
          this.showModal = true
          this.loading = false
          this.$toast(res.errMsg)
        } else {
          this.loading = false
          this.$toast(res.errMsg)
        }
      })
    },
    aliPay (obj) {
      ap.tradePay({
        tradeNO: obj.aliTradeNo
      }, (res) => {
        console.log('aliPay', res)
        // ap.alert(res.resultCode)
        if (res.resultCode === '9000') {
          this.paySuccess(obj)
        }
      })
    },
    callWXPay (obj) {
      function payCallback(payResult) {
        // 客户端，支付成功
        if (payResult === 'ok') {
          console.log('支付成功')
          this.paySuccess(obj)
          // 客户端，用户取消
        } else if (payResult === 'cancel') {
          console.log('支付失败')
          // do nothing
          // 客户端，其他错误导致支付失败
        } else {
          this.$toast('支付失败，请稍后重试')
        }
      }
      WXPay.callWXPay(obj, payCallback.bind(this))
    },
    paySuccess (obj) {
      const {tradeNo} = obj
      this.$router.replace({ path: '/openCardSuccess', query: { router: 'openCard',tradeNo } })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`
      } else if (type === "day") {
        return `${value}日`
      }
      return value;
    },
    confirm(e) {
      this.cancel()
      this.birthday = this.$moment(e).format("YYYY-MM-DD")
      this.currentDate = e
    },
    cancel() {
      this.showDate = false
    },
    onInput(value) {
      console.log('onInput', value)
    },
    hideModal () {
      this.checkCode = ''
      this.showModal = false
    },
    onDelete() {
      console.log('onDelete')
    }
  }
};
</script>

<style scoped lang="stylus">
@import '../../assets/stylus/mixins.styl'
.member-detail
    width 100vw
    height 100vh
    background #ECEDEC
    .member-section
        width 90vw
        margin 0 auto
        h4
            font-size 17px
            line-height 3em
            color #333
        .member-box
            padding 18px
            background #fff
            border-radius 6px
    .van-cell__title
      width 90px
      flex none
      text-align left
    .van-radio
      margin-right 10px
.bottom-bar
  position fixed
  left 0
  right 0
  padding 10px 20px
  bottom 0
</style>
